import { render, staticRenderFns } from "./AdminKeywords.vue?vue&type=template&id=85379bd0&"
import script from "./AdminKeywords.vue?vue&type=script&lang=js&"
export * from "./AdminKeywords.vue?vue&type=script&lang=js&"
import style0 from "./AdminKeywords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports